export default "__VITE_ASSET__g56VTmXq__"